import api from './api';

export const getRolesApi = () => api().get('/roles');
